import request from '@/utils/changanRequest'
// 新增居民求助信息
export function addAssistance(data) {
  return request({
    url: '/system/assistance',
    method: 'post',
    data: data
  })
}

// 查询居民求助信息详细
export function getAssistance(id) {
  return request({
    url: '/system/assistance/' + id,
    method: 'get'
  })
}
// 查询居民求助类型列表
export function listType(query) {
  return request({
    url: '/system/assistanceType/list',
    method: 'get',
    params: query
  })
}